import { getGuardianStatus } from "../engine/guardianStatus.js";
import { resolveDataState } from "./dataDiagnostics.js";

export const GUARDIAN_STALE_AFTER_MS = 3 * 60 * 1000;

function clampScore(value) {
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return null;
  return Math.max(0, Math.min(100, Math.round(numeric)));
}

export function mapGuardianApiState(raw) {
  if (!raw || typeof raw !== "object") return null;

  const score = clampScore(raw.stabilityScore ?? raw.score);
  if (score === null) return null;

  const status = getGuardianStatus(score);
  const engineStatus = String(raw.engineStatus ?? raw.status ?? "").trim().toLowerCase() || null;
  const baseDiagnostics = resolveDataState({
    updatedAt: raw.updatedAt ?? raw.lastUpdated ?? null,
    staleAfterMs: GUARDIAN_STALE_AFTER_MS,
    itemCount: 1,
  });
  const dataState = engineStatus === "degraded" && baseDiagnostics.state === "ok"
    ? "degraded"
    : baseDiagnostics.state;

  return {
    score,
    status: status.label,
    level: status.level,
    message: status.message,
    lastUpdate: raw.updatedAt ?? raw.lastUpdated ?? null,
    dataSource: "guardian_api",
    syncStatus: dataState === "stale" ? "stale" : "live",
    dataState,
    timestampLabel: baseDiagnostics.timestampLabel,
    engineStatus,
    riskFlagCount: Array.isArray(raw.riskFlags) ? raw.riskFlags.length : 0,
    alertCount: Array.isArray(raw.alerts) ? raw.alerts.length : 0,
    topSignalCount: Array.isArray(raw.topSignals) ? raw.topSignals.length : 0,
    apiData: raw,
  };
}
